<template>
  <div class="relative">
    <div class="flex items-center">
      <div>
        <div class="text-lms_black-300 text-[15px] font-semibold">
          {{ overlay.name }}
        </div>
        <div class="text-lgmx_gray-900 text-[13px]">
          {{ formattedDate }}
        </div>
      </div>
      <div class="ml-auto" @click.stop>
        <UIIconButton
          icon="TrashIcon"
          tooltip="Delete"
          @click="$emit('delete', overlay)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { format } from 'date-fns';
import UIIconButton from '@/components/ui/UIIconButton.vue';

const props = defineProps({
  overlay: {
    type: Object,
    required: true,
  },
});

defineEmits(['delete']);

const formattedDate = computed(() => {
  if (!props.overlay.created_at) return '';
  return format(new Date(props.overlay.created_at), 'MMM d, yyyy');
});
</script>
